// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadFile_wrapper__GNY-E","file_name":"UploadFile_file_name__klT-G"};